import { render, staticRenderFns } from "./DashboardView.vue?vue&type=template&id=976e1124&scoped=true&"
import script from "./DashboardView.vue?vue&type=script&lang=js&"
export * from "./DashboardView.vue?vue&type=script&lang=js&"
import style0 from "./DashboardView.vue?vue&type=style&index=0&lang=css&"
import style1 from "./DashboardView.vue?vue&type=style&index=1&id=976e1124&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "976e1124",
  null
  
)

export default component.exports